import Entity from "../entity";

export default class CharlieCampo extends Entity<number>{
    nombreCampo: string;
    valorCampo: string;
}